import { render, staticRenderFns } from "./StandardRequests.vue?vue&type=template&id=1e394ffb&scoped=true"
import script from "./StandardRequests.vue?vue&type=script&lang=js"
export * from "./StandardRequests.vue?vue&type=script&lang=js"
import style0 from "./StandardRequests.vue?vue&type=style&index=0&id=1e394ffb&prod&scoped=true&lang=scss"
import style1 from "./StandardRequests.vue?vue&type=style&index=1&id=1e394ffb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e394ffb",
  null
  
)

export default component.exports